import { CART_SOURCES } from '../../pages/instances/sales/orders/orders-single/cartSourceIsolation';

const firstPresent = (...values) => {
  for (const value of values) {
    if (value === null || value === undefined) continue;
    if (typeof value === 'string' && value.trim() === '') continue;
    return value;
  }
  return null;
};

const sameIdentity = (a, b) => {
  if (a === null || a === undefined || b === null || b === undefined) return false;
  return String(a).trim() === String(b).trim();
};

export const resolveCatalogProductId = (item = {}) =>
  firstPresent(
    item?.ProductId,
    item?.productId,
    item?.ASIProductId,
    item?.asiProductId,
  );

export const resolvePersistedOrderItemId = (item = {}, { source } = {}) => {
  const explicitOrderItemId = firstPresent(
    item?.persistedOrderItemId,
    item?.PersistedOrderItemId,
    item?.OrderItemId,
    item?.orderItemId,
    item?.dbItemId,
    item?.PersistedOrderItemId,
    item?.persistedOrderItemId,
    item?.OrderProductId,
    item?.orderProductId,
  );

  if (explicitOrderItemId !== null) return explicitOrderItemId;

  if (String(source || '').trim() === CART_SOURCES.ORDER) {
    return firstPresent(item?.id, item?.Id);
  }

  if (firstPresent(item?.cartLineId, item?.itemId)) return null;

  const legacyId = firstPresent(item?.id);
  if (legacyId === null) return null;

  const catalogProductId = resolveCatalogProductId(item);
  if (sameIdentity(legacyId, catalogProductId)) return null;

  return legacyId;
};

export const resolveSourceOrderItemId = (item = {}, options = {}) =>
  firstPresent(
    item?.sourceOrderItemId,
    item?.SourceOrderItemId,
    item?.originalOrderItemId,
    item?.OriginalOrderItemId,
    item?.source?.sourceOrderItemId,
    item?.source?.SourceOrderItemId,
    item?.source?.originalOrderItemId,
    item?.source?.OriginalOrderItemId,
    resolvePersistedOrderItemId(item, options),
  );

export const buildProductWorkspaceIdentity = (row = {}, options = {}) => {
  const persistedOrderItemId = resolvePersistedOrderItemId(row, options);
  const cartLineId = firstPresent(row?.cartLineId, row?.itemId);

  return {
    OrderItemId: persistedOrderItemId,
    orderItemId: persistedOrderItemId,
    persistedOrderItemId,
    sourceOrderItemId: resolveSourceOrderItemId(row, options),
    cartLineId,
    id: cartLineId || persistedOrderItemId,
  };
};

export const isMasterOrderCartSource = (source = '') =>
  String(source || '').trim() === CART_SOURCES.ORDER;

export const shouldBlockProtectedOrderItemDeletion = ({
  source,
  row = {},
  protectedOrderItemIds = new Set(),
} = {}) => {
  if (!isMasterOrderCartSource(source)) return false;
  const orderItemId = Number(row?.orderItemId ?? row?.dbItemId);
  return Number.isInteger(orderItemId) && protectedOrderItemIds.has(orderItemId);
};

export const resolvePersistedOrderItemDeleteId = (row = {}) =>
  resolvePersistedOrderItemId(row);

export const resolvePersistedOrderItemCopyId = (row = {}) =>
  resolvePersistedOrderItemId(row);
